import React, { useEffect, useState } from 'react';
import { ADMIN_API_URL } from '../config/adminApi';
import { formatBannerMessage } from '../utils/bannerFormat';
import { fetchWithTimeout } from '../utils/fetchWithTimeout';
import './SeasonalBanner.css';

const TYPE_LABEL = {
  vigilance: 'Vigilance',
  saisonnier: 'Saisonnière',
  prevention: 'Prévention',
  information: 'Information',
  autre: 'Autre',
};
const TYPE_ICON = {
  vigilance: '⚠️',
  saisonnier: '📅',
  prevention: '🛡️',
  information: 'ℹ️',
  autre: '📌',
};

// Bandeau d'alerte (5 types — vigilance/saisonnier/prevention/information/autre)
// — affiché sur tout le site, sous la Navbar. Le type "vacances" est géré
// séparément par <VacationExperience /> (voir App.js), fonctionnement inchangé.
// Layout desktop : icône+label à gauche | message centré | CTA optionnel à droite.
// Non désactivable par le visiteur (pas de bouton fermer) : voir SeasonalBanner.css.
export default function SeasonalBanner() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    fetchWithTimeout(`${ADMIN_API_URL}/api/banners/active`)
      .then(data => setBanner(data))
      .catch(() => {});
  }, []);

  if (!banner) return null;

  return (
    <div className={`seasonal-banner seasonal-banner--${banner.type}`}>
      <div className="seasonal-banner-glow" aria-hidden="true" />

      <div className="seasonal-banner-left">
        <span className="seasonal-banner-icon" aria-hidden="true">{TYPE_ICON[banner.type] || '⚪'}</span>
        <span className="seasonal-banner-label">{TYPE_LABEL[banner.type] || 'Autre'}</span>
      </div>

      <div className="seasonal-banner-center">
        <span
          className="seasonal-banner-text"
          dangerouslySetInnerHTML={{ __html: formatBannerMessage(banner.message) }}
        />
      </div>

      {banner.cta_enabled ? (
        <div className="seasonal-banner-right">
          <a href={banner.cta_href || '/#contact'} className="seasonal-banner-cta">
            {banner.cta_text}
          </a>
        </div>
      ) : (
        <div className="seasonal-banner-right" aria-hidden="true" />
      )}
    </div>
  );
}
